import React, { useEffect, useState } from 'react'
import "./IgnoreProjects.css";
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../../utils/apiConfig';

const IgnoreProjects = ( {currentProjectId} ) => {

    const [projects, setProjects] = useState([]);
    const [loadingProjects, setLoadingProjects] = useState(true);
    const [errorProjects, setErrorProjects] = useState(null);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/projects`);
                if (!response.ok) throw new Error("Failed to fetch projects");
                const data = await response.json();

                const filteredProjects = data.filter((project) => {
                    return Number(project.id) !== Number(currentProjectId);
                });

                setProjects(filteredProjects);
            } catch (err) {
                setErrorProjects(err.message);
            } finally {
                setLoadingProjects(false);
            }
        };

        fetchProjects();
    }, [currentProjectId]);

    if (loadingProjects)
        return <p className="except-project-loading">Loading projects...</p>;

    if (errorProjects)
        return <p className="except-project-error">Error: {errorProjects}</p>;

    return (
        <div className="except-project-grid">
            {projects.map((project) => (
                <div key={project.id} className="except-project-card">
                    {project.image_url && (
                        <img
                            src={ API_BASE_URL + `/images/` + project.image_url}
                            alt={project.title}
                            className="except-project-image"
                        />
                    )}
                    <h2 className="except-project-title">{project.project_name}</h2>
                    <Link to={"/project/" + project.id} className="except-project-link">
                        View Project →  </Link>

                </div>
            ))}
        </div>
    );
}

export default IgnoreProjects